import { render, staticRenderFns } from "./cs-portal-permissions.vue?vue&type=template&id=cec9f95c"
import script from "./cs-portal-permissions.vue?vue&type=script&lang=js"
export * from "./cs-portal-permissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports